export const VA_BANK_NAME = 'va_bank_name';
export const VA_ACCOUNT_NUMBER = 'va_account_number';

export const VA_UNIT_FIELDS = [
  VA_BANK_NAME,
  VA_ACCOUNT_NUMBER,
];



// WEBPACK FOOTER //
// ./src/constants/virtualAccount.js